import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CONTACT, NAV_LINKS, OFFICES, LEGAL_LINKS } from "../mock";
import { scrollTo } from "./Navbar";
import Logo from "./Logo";

const Footer = () => {
  return (
    <footer className="bg-1 border-t border-line" data-testid="footer">
      <div className="max-w-6xl mx-auto px-6 lg:px-12 pt-20 pb-10">
        <div className="text-white mb-12"><Logo height={48} /></div>
        <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
          <h4 className="text-2xl lg:text-3xl text-green font-light">Oficinas y centros de trabajo</h4>
          <span className="hidden sm:block w-16 h-px" style={{ backgroundColor: "var(--green-light)" }} />
          <button onClick={() => scrollTo("contacto")} className="link-arrow text-2xl lg:text-3xl text-white/85 hover:text-white font-light text-left" data-testid="footer-contact-cta">
            Solicitar un estudio <ArrowRight className="w-6 h-6" />
          </button>
        </div>

        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-8">
          {OFFICES.map((o, i) => (
            <div key={o.name} className="border-b border-line pb-3" data-testid={`footer-office-${i}`}>
              <p className="label !text-[0.62rem]">{o.name}</p>
              {o.lines.map((l) => <p key={l} className="text-white/80 text-sm mt-1">{l}</p>)}
            </div>
          ))}
        </div>

        <nav className="mt-20 flex flex-wrap justify-center gap-x-8 gap-y-3">
          <button onClick={() => scrollTo("top")} className="text-muted hover:text-white text-sm transition-colors" data-testid="footer-nav-inicio">Inicio</button>
          {NAV_LINKS.map((l) => (
            <button key={l.id} onClick={() => scrollTo(l.id)} className="text-muted hover:text-white text-sm transition-colors" data-testid={`footer-nav-${l.id}`}>{l.label}</button>
          ))}
        </nav>
        <div className="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-2 text-xs text-muted">
          {LEGAL_LINKS.map((l) => <Link key={l.to} to={l.to} className="hover:text-white transition-colors" data-testid={`footer-legal-${l.to.slice(1)}`}>{l.label}</Link>)}
          <a href={CONTACT.linkedin} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-testid="footer-linkedin">LinkedIn</a>
        </div>
        <p className="mt-10 text-center text-[11px] text-muted">© {new Date().getFullYear()} Arlan. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;
